import type { FunctionComponent } from 'react';
import { BreadCrumbsBar } from '../../../components/BreadCrumbs/BreadCrumbs';
import { useStreetPageQuery } from '../../graphql/useStreetPageQuery';

export const StreetPageBreadCrumbsWithData: FunctionComponent = () => {
  const breadcrumbs = useStreetPageQuery()?.data?.streetPageBySlug?.breadCrumbs;
  if (!breadcrumbs) return null;

  return <BreadCrumbsBar crumbs={breadcrumbs} />;
};
